'use strict';

module.exports = [
  '$modal',
  '$scope',
  'SelectorFilterMixin',
  'header',
  'toString',
  'currentValue',
  'currentFilter',
  'loadList',
  SelectController];

function SelectController(
  $modal,
  $scope,
  SelectorFilterMixin,
  header,
  toString,
  currentValue,
  currentFilter,
  loadList,
) {
  const vm = $scope.selector = {
    onSelect: onSelect,
    cancel: cancel,
    currentValue: currentValue,

    header: header,
    toString: toString
  };
  const filterService = SelectorFilterMixin(vm, $scope, toString);

  filterService.initFiltering(loadList(), currentFilter);

  function onSelect(result) {
    document.getElementById("search-filter").blur();
    $modal.hide(result);
  }

  function cancel() {
    document.getElementById("search-filter").blur();
    $modal.cancel();
  }
}


// WEBPACK FOOTER //
// ./src/js/core-components/selectors/SelectController.js